import React from "react";
import "./CrudApi.css";
import { useState } from "react";
import axios from 'axios'
import { useNavigate } from "react-router-dom";

const CrudApi = () => {
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate('')

  const handleSubmit = (e) =>{
    e.preventDefault();
    axios.post("https://646b154b7d3c1cae4ce32640.mockapi.io/crudapi", {
        name, 
        age,
        email
    }).then((result) => {
        navigate('/read')
        
    }).catch((err) => {
        
    });
  }
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 border offset-4 d-flex flex-column align-items-center">
            <h1 className="text-success">Calling Api With Crud Operation </h1>

            <form onSubmit={handleSubmit} className=" d-flex flex-column align-items-center">
              <label>Name</label>
              <input type="text" value= {name} onChange={(e)=>setName(e.target.value)} className="infield" placeholder="Name" />
              <br />
              <label>Age</label>
              <input type="number" value= {age} onChange={(e)=>setAge(e.target.value)} className="infield" placeholder="Age" />
              <br />
              <label>Email</label>
              <input type="email" value = {email} onChange={(e)=>setEmail(e.target.value)} className="infield" placeholder="Email" />
              <br />

              <button className="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrudApi;
